<template>
  <div class="div-phone"> 
    <div id="div-icon-phone" class="div-icon-mobile">
        <a href="tel:19006888">
          <img class="icon-phone-img" src="/img/icon_phone.png" alt="">
        </a>
    </div>
    <div id="div-icon" class="div-icon">
      <!-- <div style="height:58px;width:58px;"> -->
        <img class="icon-phone-img" src="/img/icon_phone.png" alt="">
      <!-- </div> -->
    </div>
    <div id="div-phone-number" class="div-phone-number" @click="callPhone">
      <a href="tel:19006888">
        <img class="phone-number-img" src="/img/phone_number.png" alt="">
      </a>
    </div>
  </div>
</template>
<script>
export default {
  methods:{
    callPhone(){
      window.location.tel="19006888";
    },
    // hideIcon(){
    //   document.getElementById('div-phone-number').style.display = "block";
    //   document.getElementById('div-icon').style.display = "none";
    // },
    // showIcon(){
    //   document.getElementById('div-phone-number').style.display = "none";
    //   document.getElementById('div-icon').style.display = "block";
    // }
  }
}
</script>
<style scoped>
.div-phone{
  position: relative;
  visibility: visible;
  background-color: transparent;
  width: 60px;
  height: 60px;
  cursor: pointer;
  z-index: 11;
  -webkit-backface-visibility: hidden;
  -webkit-transform: translateZ(0);
  transition: visibility .8s;
  left: 0;
  bottom: 0;
}

.div-phone #div-icon-phone{
  width: 50px;
  height: 50px;
  top: 0px;
  right: 10px;
  position: absolute;
  background-size: 20px;
  border-radius: 100%;
  -webkit-animation: phonering-alo-circle-img-anim 1s infinite ease-in-out;
  animation: phonering-alo-circle-img-anim 1s infinite ease-in-out;
  -webkit-transform-origin: 50% 50%;
  -ms-transform-origin: 50% 50%;
  transform-origin: 50% 50%;
  display: none;
}
.div-phone .div-icon {
  width: 53px;
  height: 53px;
  top: 3px;
  right: 1px;
  position: absolute;
  -webkit-animation: phonering-alo-circle-img-anim 1s infinite ease-in-out;
  animation: phonering-alo-circle-img-anim 1s infinite ease-in-out;
  -webkit-transform-origin: 50% 50%;
  -ms-transform-origin: 50% 50%;
  transform-origin: 50% 50%;
  display: block;
}
.div-phone .div-phone-number {
  max-width: 230px;
  position: fixed;
  top: 0;
  left: 0;
  cursor: pointer;
  transform: translate(250px,2px);
  transition: .5s;
}
.div-phone .icon-phone-img{
  animation: shake 10s;
  animation-iteration-count: infinite;
  animation-delay: 3s;
}
@keyframes shake {
  0% {
    -webkit-transform: rotate(0) scale(1) skew(1deg);
  }
  1% {
    -webkit-transform: rotate(-25deg) scale(1) skew(1deg);
  }
  2% {
    -webkit-transform: rotate(25deg) scale(1) skew(1deg);
  }
  3% {
    -webkit-transform: rotate(-25deg) scale(1) skew(1deg);
  }
  4% {
    -webkit-transform: rotate(25deg) scale(1) skew(1deg);
  }
  5% {
    -webkit-transform: rotate(-25deg) scale(1) skew(1deg);
  }
  6% {
    -webkit-transform: rotate(25deg) scale(1) skew(1deg);
  }
  7% {
    -webkit-transform: rotate(-25deg) scale(1) skew(1deg);
  }
  8% {
    -webkit-transform: rotate(25deg) scale(1) skew(1deg);
  }
  9% {
    -webkit-transform: rotate(-25deg) scale(1) skew(1deg);
  }
  10% {
    -webkit-transform: rotate(25deg) scale(1) skew(1deg);
  }
  100% {
    -webkit-transform: rotate(0) scale(1) skew(1deg);
  }
}
@media (min-width: 768px){
  .div-phone:hover{
    width: 230px;
  }

  .div-phone:hover .div-phone-number{
    transform: translate(0px,2px);
  }
}

@keyframes slide {
  0% { width: 110px; }
  100% { width: 230px; }
}

@media (max-width: 768px){
  .div-phone .div-icon{
    display: none;
  }
  .div-phone{
    width: 50px;
    height: 50px;
  }
  .div-phone #div-icon-phone{
    display: block;
  }
}
</style>